import storageManager from '@/api/storageManager';
import {
	TRAFFIC_JUNKY_BASE_URL,
	TRAFFIC_JUNKY_IDSYNC_SCRIPT_ID,
	TRAFFIC_JUNKY_IDSYNC_SITE_ID,
	TRAFFIC_JUNKY_IDSYNC_SRC,
	TRAFFIC_JUNKY_MEMBER_ID,
} from './tracking.constants';

const BROWSING_PERSON_STORAGE_KEY = 'bp';

let trafficJunkyIdSyncInitialized = false;

export const getBrowsingPersonId = (explicitId) => {
	try {
		return (
			(explicitId && String(explicitId)) ||
			storageManager.utm.getBrowsingPersonId() ||
			localStorage.getItem(BROWSING_PERSON_STORAGE_KEY) ||
			null
		);
	} catch {
		return null;
	}
};

const resolveTransactionId = (browsingPersonId) =>
	browsingPersonId ||
	`tj_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

const runTrafficJunkyIdSync = () => {
	try {
		window.idsync.config(TRAFFIC_JUNKY_IDSYNC_SITE_ID).fp_get().sync();
		trafficJunkyIdSyncInitialized = true;
	} catch {}
};

export const initTrafficJunkyIdSync = () => {
	if (trafficJunkyIdSyncInitialized) {
		return;
	}

	let script = document.getElementById(TRAFFIC_JUNKY_IDSYNC_SCRIPT_ID);

	if (!script) {
		script = document.createElement('script');
		script.id = TRAFFIC_JUNKY_IDSYNC_SCRIPT_ID;
		script.async = true;
		script.src = TRAFFIC_JUNKY_IDSYNC_SRC;
		document.head.appendChild(script);
	}

	script.onload = runTrafficJunkyIdSync;
	runTrafficJunkyIdSync();
};

export const fireTrafficJunkieEvent = (payload) => {
	const { event, description = '' } = payload;
	const browsingPersonId = getBrowsingPersonId(payload.browsingPersonId);
	const params = new URLSearchParams({
		a: event.actionId,
		member_id: TRAFFIC_JUNKY_MEMBER_ID,
		cb: String(Date.now()),
		cti: resolveTransactionId(browsingPersonId),
		ctv: '',
		ctd: description,
	});

	document.getElementById(event.pixelId)?.remove();

	const pixel = document.createElement('img');
	pixel.id = event.pixelId;
	pixel.width = 1;
	pixel.height = 1;
	pixel.alt = '';
	pixel.setAttribute('border', '0');
	pixel.style.display = 'none';
	pixel.src = `${TRAFFIC_JUNKY_BASE_URL}?${params.toString()}`;
	document.body.appendChild(pixel);
};
